import { classificationByLabels } from "../../../../lib/enums/ThreatStatusEnum";

export const convertGoodwareClassification = classification =>
  classification === "NO_THREATS_FOUND" || classification === "CLEAN"
    ? ["NO THREATS FOUND", "GOODWARE"]
    : [classification, classification];

export const transformSignaturesRiskFactor = riskFactor => {
  let classification;
  if (riskFactor >= 0 && riskFactor <= 5) {
    classification = classificationByLabels.GOODWARE;
  } else if (riskFactor === 6 || riskFactor === 7) {
    classification = classificationByLabels.SUSPICIOUS;
  } else if (riskFactor >= 8 && riskFactor <= 10) {
    classification = classificationByLabels.MALICIOUS;
  } else {
    classification = classificationByLabels.UNKNOWN;
  }
  return classification;
};
